<template>
    <div class="page">
        <div class="title">
            {{ infoTitle }}
            <!-- <div class="right">
                <div class="search">
                    <input type="" placeholder="请输入指标名称" />
                    <img src="../assets/img/search.png" />
                </div>
                <div class="btn">搜索</div>
            </div> -->
        </div>

        <div class="menu">
            
            <div class="search">
                <div class="item">
                    区域
                    <el-select multiple collapse-tags v-model="regionVal.pro" placeholder="请选择省" v-if='regionType == 3 || regionType == 2 || regionType == 1'>
                        <el-option
                            v-for="v in regionArr.pro"
                            :key="v.id"
                            :label="v.classname"
                            :value="v.id"
                        >
                        </el-option>
                    </el-select>
                    <el-select multiple collapse-tags v-model="regionVal.city" placeholder="请选择市" v-if='regionType == 3 || regionType == 2'>
                        <el-option
                            v-for="v in regionArr.city"
                            :key="v.id"
                            :label="v.classname"
                            :value="v.id"
                        >
                        </el-option>
                    </el-select>
                    <el-select multiple collapse-tags v-model="regionVal.area" placeholder="请选择区" v-if='regionType == 3'>
                        <el-option
                            v-for="v in regionArr.area"
                            :key="v.id"
                            :label="v.classname"
                            :value="v.id"
                        >
                        </el-option>
                    </el-select>
                </div>

                <div class="item">
                    时间
                    <el-date-picker
                        v-model="form.strtime"
                        type="year"
                        value-format="yyyy"
                        :picker-options="pickerOption"
                        placeholder="开始年份">
                    </el-date-picker>
                    至
                    <el-date-picker
                        v-model="form.endtime"
                        type="year"
                        value-format="yyyy"
                        :picker-options="pickerOption"
                        placeholder="结束年份">
                    </el-date-picker>
                </div>

                <div class="btns">
                    <div @click="search()">搜索</div>
                    <div class="plain" @click='reset()'>重置</div>

                    <div class="plain" @click='down()'>导出</div>
                </div>
            </div>
            <div class="chartnav">
                <!-- <div class="item check">
                    <img src="../assets/img/tu1.png" /> 表格数据
                </div> -->
                <div class="item" :class="chatType == 'table' ? 'check' : ''" @click="showTable()">
                    <img src="../assets/img/tu1.png" /> 数据表
                </div>
                <div class="item" :class="chatType == 'bing' ? 'check' : ''" @click="piechart()">
                    <img src="../assets/img/tu2.png" /> 饼状图
                </div>
                <div class="item" :class="chatType == 'zhu' ? 'check' : ''" @click="barchart()">
                    <img src="../assets/img/tu3.png" /> 柱状图
                </div>
                <div class="item" :class="chatType == 'xian' ? 'check' : ''" @click="linechart()">
                    <img src="../assets/img/tu4.png" /> 折线图
                </div>
            </div>
        </div>

        <div class="chartbox" v-show="chatType != 'table'">
            <div class="ttitle">{{ infoTitle || '-' }}</div>
            <div
                class="echart"
                id="mychart"
                :style="{ minWidth: '100%', height: '400px', top: '-34px' }"
            ></div>
        </div>

        <!-- <div class="table" :class="chatType == 'table' ? 'on' : ''"> -->
        <div class="table" :class="chatType == 'table' ? 'showSelectAll' : ''">
            <div class="trcheck">
                <!-- <el-checkbox-group v-model="selectYear" v-show="chatType != 'table'"> -->
                <el-checkbox-group v-model="selectYear">
                    <el-checkbox v-for="(v, k) in titleArr" :key='v' :label='v'></el-checkbox>
                </el-checkbox-group>
                <!-- <div v-for="(v, k) in titleArr" :key='v'>
                    {{v}}
                    <el-checkbox v-model="checked">备选项</el-checkbox>
                </div> -->
            </div>
            <el-table ref="table" :data="conArr" @sort-change="tableSort" style="width: 100%" @select="handleSelectionChange" @select-all='handleSelectionChange'>
                <el-table-column fixed type="selection" width="50"></el-table-column>
                <el-table-column fixed prop="title" label="地区" width="150"></el-table-column>
                <el-table-column :prop="v" sortable :label="v" :width="(1490-200)/titleArr.length"  v-for="(v, k) in titleArr" :key='v'></el-table-column>
            </el-table>
            <el-button v-if='!isLogin()' type="primary" style='margin:20px auto;display:block;' @click="more()" >获取更多</el-button>
        </div>

        <div class="tipbox">
            <div class="ttitle">注释说明</div>
            <div class="content">
                {{content}}
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
import bus from "../utils/bus.js";//导入中间件

// import region from "../mixin/region.js";

// import request1 from "../utils/request1";

export default {
    name: "Info",
    // mixins:[region ],

    data() {
        const that = this;
        return {
            title:'',
            id:0,
            regionType:1,
            titleArr:[],
            conArr:[],
            protoArr:[],
            content:'',
            // value1:'',
            chatType:'table',
            regionArr:{
                pro:[],
                city:[],
                area:[],
            },
            regionVal:{
                pro:[],
                city:[],
                area:[],
            },
            form:{
                type:'',
                level:'',
                region_level:'',
                area:'',
                strtime:'',
                endtime:'',
            },
            search_val:{},
            searchYearRange_start:'',
            searchYearRange_end:'',
            pickerOption:{
                disabledDate(time){
                    return(
                        time.getFullYear() < that.searchYearRange_start || time.getFullYear() > that.searchYearRange_end
                    );
                }
            },
            selectYear:[],
            selectYearCookie:[],
            selection:[],
            page:1,
            loading:false,
        };
    },
    watch: {
        $route(to) {

            this.id = to.params.id;
            this.regionType = to.params.type;
            this.form.type = to.params.id;
            this.form.level = to.params.type;

            this.reset();
            
        },
        'regionVal.pro'(val){
            if(val.length > 0) this.getRegion('city', val);
            this.regionVal.city = [];
            this.regionArr.city = [];
            this.regionVal.area = [];
            this.regionArr.area = [];
        },
        'regionVal.city'(val){
            if(val.length > 0) this.getRegion('area', val);
            this.regionVal.area = [];
            this.regionArr.area = [];
        },
        selectYear(val){
            // console.log(val);
            this.tableColor();
        },
        "$store.state.token"(){
            this.getInfo();
            // console.log('登陆了');
        }
    },
    mounted() {
        this.id = Number(this.$route.params.id);
        this.regionType = Number(this.$route.params.type);
        this.form.type = Number(this.$route.params.id);
        this.form.level = Number(this.$route.params.type);
        this.search_val = {...this.form};


        // this.title = this.$route.params.title;
        this.getRegion('pro');

        // console.log(this.token,'token');
        
        if(this.toke != '')  this.getInfo();

        this.$post('/api/qizhi').then(res=>{
            this.searchYearRange_start = res.data.str;
            this.searchYearRange_end = res.data.end;
        })
        // window.addEventListener('scroll', this.scrollEvent,false);
        bus.$on("sendMessage",(val)=>{
            if(this.isLogin()){
                this.loadMore(val);
            }
        })
    },
    destroyed () {
        bus.$off('sendMessage')
    },
    methods: {
        tableSort(){
            // console.log(123);
            setTimeout(()=>{
                this.tableColor();
            },100);
        },
        more(){
            this.$post('/api/ba',{id:2}).then(res=>{
                this.$alert(res.data);
            })
        },
        //刷新
        reset(){
            this.regionArr = {
                pro:[],
                city:[],
                area:[],
            }
            this.regionVal = {
                pro:[],
                city:[],
                area:[],
            }
            this.form = {
                type:this.form.type,
                level:this.form.level,
                area:'',
                strtime:'',
                endtime:'',
            };
            this.page = 1;
            this.loading=false;
            this.search_val = {...this.form};

            this.getRegion('pro');
            this.showTable();
            this.getInfo();
        },
        loadMore(){
            // console.log(333);
            if(this.loading) return;
            this.page++;
            this.loading = true;
            this.getInfo();
        },
        //搜索
        search(){

            this.form.area = this.regionVal.pro.join(',');
            this.form.region_level = 1;

            if(this.regionType >=2 && this.regionVal.city.length > 0){
                this.form.area = this.regionVal.city.join(',');
                this.form.region_level = 2;

            }
            if(this.regionType == 3 && this.regionVal.area.length > 0){
                this.form.area = this.regionVal.area.join(',');
                this.form.region_level = 3;

            }
            this.search_val = {...this.form};
            this.page = 1;
            this.loading=false;
            this.getInfo();
        },
        //获取数据
        getInfo(){
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
            });
        
            this.$post('/api/service_listnew',{...this.search_val,page: this.page}).then(res=>{
                loading.close();

                for(let i in res.years){
                    if(res.years[i].listnew.length == 0) return;
                }

                setTimeout(() => {
                    this.loading = false;
                },100);
                
                if(this.page == 1){
                    this.defaultArr = res.years;
                }else{
                    let dom = document.getElementsByClassName('body')[0];
                    dom.scrollTop = dom.scrollHeight-dom.clientHeight - 220;

                    // console.log(this.defaultArr, res.years);
                    for(let i in this.defaultArr){
                        console.log(i, this.defaultArr[i]);
                        this.defaultArr[i].listnew = [...this.defaultArr[i].listnew, ...res.years[i].listnew];
                    }
                }

                res.years = this.defaultArr;

                //倒序排序 start
                let keyArr = [];
                let newData = {};
                for(let i in res.years){
                    keyArr[keyArr.length] = i;
                }
                keyArr.reverse();

                for(let i in keyArr){
                    newData[keyArr[i]+' '] = res.years[keyArr[i]];
                }
                res.years = newData;
                //倒叙排序 end

                this.protoArr = res.years; //原始数据
                this.content = res.content; //注释
                let arr = res.years;
                
                
                let selectYear  = [];
                let selection  = [];
                let titleArr = [];
                for(let i in arr){
                    titleArr[titleArr.length] = i;
                    if(selectYear.length < 5) selectYear = [i, ...selectYear];
                }
                this.titleArr = titleArr;


                let conArr = [];
                for(let i in arr){
                    for(let ii in arr[i].listnew){
                        // console.log(arr[i].listnew[ii].list[0].num);
                        let num = (arr[i].listnew[ii].list.length > 0) ? this.sgToFixed(arr[i].listnew[ii].list[0].num*1) : '0.00';

                        let title = arr[i].listnew[ii].classname; 
                        let check = false;
                        for(let iii in conArr){
                            if(conArr[iii].title == title){
                                check = true;
                                conArr[iii][i] = num;
                                break;
                            }   
                        }
                        if(!check){
                            let data = {title:title}
                            for(let iii in titleArr){
                                data[titleArr[iii]] = titleArr[iii] == i ? num : null;
                            }
                            conArr[conArr.length] = data;
                        }
                    }
                }
                this.conArr = conArr;


                //默认前五条选中
                this.$nextTick(()=>{
                    this.conArr.forEach((item,index) => {
                        // console.log(index);
                        if(index < 10){
                            this.$refs.table.toggleRowSelection(item, true)
                            selection = [item, ...selection];
                        }
                    })
                    this.selection = selection;
                    this.selectYear = selectYear;
                    // this.selectYearCookie = selectYear;
                    this.tableColor();
                })

            },err=>{
                loading.close();
            })
            // this.piechart();
        },
        sgToFixed(num,digit=2 ){
            // console.log(num);
            let nums=(num||0).toString().split('.');
            return nums[0]+'.'+(nums[1]||'0').padEnd(digit, "0");
        },
        //下载
        down(){
            let titles = [], ids = [];
            for(let i in this.selection){
                titles[titles.length] = this.selection[i].title
            }
            for(let i in this.protoArr){
                if(this.selectYear.indexOf(i) == -1) continue;
                let list = this.protoArr[i].listnew;
                for(let ii in list){
                    if(titles.indexOf(list[ii].classname) != -1){
                        for(let iii in list[ii].list){
                            ids[ids.length] = list[ii].list[iii].id
                            // console.log(i, list[ii].classname);
                        }
                    }
                }
                // break;
            }
            console.log(ids.length);
            ids = ids.join(',');


            this.$post('api/yanzheng',{
                token: this.token,
                type: this.form.type,
                area: this.form.area,
                strtime: this.form.strtime,
                endtime: this.form.endtime,
                ids:ids
            }).then(res=>{
                let canshu = '';
                for(let i in this.form){
                    canshu += i+'='+this.form[i]+'&';
                }
                let url = '/api/exports?'+canshu+'size='+this.userInfo.size+'&token='+this.token+'&ids='+ids;
                console.log(url);
                window.location.href = url;
            })
            // return false;
            
        },
        //地区筛选
        getRegion(type, id = 0){
            if(type == 'pro'){
                this.$post('/api/area',{pid: 0}).then(res=>{
                    this.regionArr[type] = res.data;
                    // console.log(this.regionArr.pro);
                })
            }else{
                this.$post('/api/areashaixuan',{str: id.join(',')}).then(res=>{
                    this.regionArr[type] = res.data;
                    // console.log(this.regionArr.pro);
                })
            }
        } ,
        //left选中限制
        handleSelectionChange(selection, val) {
            if(this.chatType == 'table'){

            }else if(this.chatType == 'bing'){
                if(selection.length == 0){
                    this.$refs.table.toggleRowSelection(val, true);
                    return false;
                }else if(selection.length > 1){
                    let del_row = selection[selection.length-2]; //selection.shift();
                    this.$refs.table.toggleRowSelection(del_row, false);
                }
                selection = [selection[selection.length-1]];
            }else if (selection.length > 10) {
                let del_row = selection[selection.length-1]; //selection.shift();
                this.$refs.table.toggleRowSelection(del_row, false); // 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
                this.$message({
                    message: '最多可以选择10条',
                    type: 'warning'
                });
                return false;
            }
            this.selection = selection;
            this.tableColor();
        },
        //表格颜色
        tableColor(refresh = true){
            
            let table = this.$refs.table.$el;
            let lr = this.selection, l = [];
            let lefts = table.getElementsByClassName('el-table__body')[1].getElementsByTagName('tr');

            for(let i=0; i<lr.length; i++){
                let title = lr[i].title.trim();
                for(let ii=0; ii<lefts.length; ii++){
                    if(lefts[ii].getElementsByTagName('td')[1].innerHTML.indexOf(title) != -1){
                        l[l.length] = ii;
                        break;
                    }
                }
            }
            let tr = this.selectYear, t = [];
            let ths = table.getElementsByClassName('has-gutter')[0].getElementsByTagName('th');
            for(let i=0; i<tr.length; i++){
                for(let ii=0; ii<ths.length; ii++){
                    if(ths[ii].innerHTML.indexOf(tr[i]) != -1){
                        t[t.length] = ii;
                        break;
                    } 
                }
            }
            // console.log( this.selection,l,t);
            let tdAll = table.getElementsByClassName('el-table__body')[0].getElementsByTagName('td');
            for(let i=0; i<tdAll.length; i++){
                tdAll[i].style.background='';
                tdAll[i].style.color='';
            }
            let trs = table.getElementsByClassName('el-table__body')[0].getElementsByTagName('tr');
            for(let i in l){
                let tds = trs[l[i]].getElementsByTagName('td');
                for(let ii in t){
                    let dom = tds[t[ii]];
                    dom.style.background='#0756A5';
                    dom.style.color='#fff';
                }
            }
            if(!refresh) return;
            if(this.chatType == 'bing'){ this.piechart_r() }
            if(this.chatType == 'zhu'){ this.barchart_r() }
            if(this.chatType == 'xian'){ this.linechart_r() }
        },
        
        showTable(){ //图表
            this.chatType = 'table';
            // this.selectYearCookie = this.selectYear;
            // this.selectYear = [];
            // console.log(this.selectYearCookie);
        },  
        linechart() { // 折线图
            this.chatType = 'xian';
            // this.selectYear = this.selectYearCookie;
            let selection = [];
            for(let i in this.conArr){
                if(i < 10){
                    this.$refs.table.toggleRowSelection(this.conArr[i], true);
                    selection[selection.length] = this.conArr[i];
                }else{
                    this.$refs.table.toggleRowSelection(this.conArr[i], false);
                }
            }
            this.selection = selection;
            this.tableColor(false);
            this.linechart_r();
        },
        linechart_r(){ //折线图
            let selectArr = this.$refs.table.selection;
            let data = [];
            let series = [];
            let seriesr = [
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#0055B8' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(0,85,184,.3)',}, {offset: 0.3,color: 'rgba(0,85,184,0.1)',}, {offset: 0.6,color: 'rgba(0,85,184,0)',}, { offset: 1, color: 'rgba(0,85,184,0.0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#7E0EB6' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(126,14,182,.3)',}, {offset: 0.3,color: 'rgba(126,14,182,0.1)',}, {offset: 0.6,color: 'rgba(126,14,182,0)',}, { offset: 1, color: 'rgba(126,14,182,0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#fa9c00' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(250,156,0,.3)',}, {offset: 0.3,color: 'rgba(250,156,0,0.1)',}, {offset: 0.6,color: 'rgba(250,156,0,0)',}, { offset: 1, color: 'rgba(250,156,0,0.0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#00b09b' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(0,176,155,.3)',}, {offset: 0.3,color: 'rgba(0,176,155,0.1)',}, {offset: 0.6,color: 'rgba(0,176,155,0)',}, { offset: 1, color: 'rgba(0,176,155,0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#90bc32' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(144,188,50,.3)',}, {offset: 0.3,color: 'rgba(144,188,50,0.1)',}, {offset: 0.6,color: 'rgba(144,188,50,0)',}, { offset: 1, color: 'rgba(144,188,50,0.0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#ED7C30' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(237,124,48,.3)',}, {offset: 0.3,color: 'rgba(237,124,48,0.1)',}, {offset: 0.6,color: 'rgba(237,124,48,0)',}, { offset: 1, color: 'rgba(237,124,48,0.0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#EF6565' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(239,101,101,.3)',}, {offset: 0.3,color: 'rgba(239,101,101,0.1)',}, {offset: 0.6,color: 'rgba(239,101,101,0)',}, { offset: 1, color: 'rgba(239,101,101,0.0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#49A7FF' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(73,167,255,.3)',}, {offset: 0.3,color: 'rgba(73,167,255,0.1)',}, {offset: 0.6,color: 'rgba(73,167,255,0)',}, { offset: 1, color: 'rgba(73,167,255,0.0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#7351E3' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(115,81,227,.3)',}, {offset: 0.3,color: 'rgba(115,81,227,0.1)',}, {offset: 0.6,color: 'rgba(115,81,227,0)',}, { offset: 1, color: 'rgba(115,81,227,0.0)',}, ]),},}, },
                    {type: 'line',smooth: true, symbolSize: 8, itemStyle:{color:'#F4B57F' }, areaStyle: { normal: {color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {offset: 0,color: 'rgba(244,181,127,.3)',}, {offset: 0.3,color: 'rgba(244,181,127,0.1)',}, {offset: 0.6,color: 'rgba(244,181,127,0)',}, { offset: 1, color: 'rgba(244,181,127,0.0)',}, ]),},}, },
            ]
            for(let i in selectArr[0]){
                let dataIndex = data.length;
                if(i!='title'){
                    if(this.selectYear.indexOf(i) == -1) continue;
                }
                data[dataIndex] = [(i == 'title' ? 'product' : i)];
                for(let ii in selectArr){
                    data[dataIndex][data[dataIndex].length] =  selectArr[ii][i]
                }
            }
            for(let i in selectArr){
                series[series.length] = seriesr[series.length];
            }
            data.sort(function(x, y){
                return x[0] - y[0];
            });
            // console.log(data);

            // return false;
            const option = {
                legend: {
                    x:'right',      //可设定图例在左、右、居中
                    padding:[0,60,0,0],   //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
                },
                tooltip: {},
                grid: {
                    x: 100,
                    y: 80,
                    x2: 30,
                    y2: 20
                },
                dataset: {
                    source:data
                },
                xAxis: {type: 'category', axisLabel: { interval:0,}},
                yAxis: {},
                series: series,
            };
            echarts.init(document.getElementById("mychart")).dispose();

            setTimeout(() => {
                this.myChart = echarts.init(document.getElementById("mychart"));
                this.myChart.setOption(option);
            }, 100);
            //随着屏幕大小调节图表
        },
        barchart() { // 柱图
            this.chatType = 'zhu';
            // this.selectYear = this.selectYearCookie;
            let selection = [];
            for(let i in this.conArr){
                if(i < 10){
                    this.$refs.table.toggleRowSelection(this.conArr[i], true);
                    selection[selection.length] = this.conArr[i];
                }else{
                    this.$refs.table.toggleRowSelection(this.conArr[i], false);
                }
            }
            this.selection = selection;
            this.tableColor(false);
            this.barchart_r();
        },
        barchart_r() { // 柱图
            
            let selectArr = this.$refs.table.selection;
            let data = [];
            let series = [];
            let seriesr = [
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#2E65FD'}},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#FEC12B' }},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#611985'}},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#1FCAA8' }},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#EF6565'}},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#0254B7'}},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#FFA100' }},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#70ad47'}},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#ed7c30' }},
                    {type: 'bar', barWidth:'5%', itemStyle:{color:'#5a9ad5'}},
            ];

            for(let i in selectArr[0]){
                let dataIndex = data.length;
                if(i!='title'){
                    if(this.selectYear.indexOf(i) == -1) continue;
                }
                data[dataIndex] = [(i == 'title' ? 'product' : Number(i))];
                for(let ii in selectArr){
                    data[dataIndex][data[dataIndex].length] =  selectArr[ii][i]
                }
            }
            for(let i in selectArr){
                series[series.length] = seriesr[series.length];
            }
            data.sort(function(x, y){
                return x[0] - y[0];
            });
            // console.log(data);
            
            const option = {
                legend: {
                    x:'right',      //可设定图例在左、右、居中
                    padding:[0,60,0,0],   //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
                },
                tooltip: {},
                grid: {
                    x: 100,
                    y: 80,
                    x2: 30,
                    y2: 20
                },
                dataset: {
                    source: data
                },
                xAxis: {type: 'category',axisLabel: { interval:0,}},
                yAxis: {
  
                },
                series:series
                // series: 
            };
            echarts.init(document.getElementById("mychart")).dispose();

            setTimeout(() => {
                this.myChart = echarts.init(document.getElementById("mychart"));
                this.myChart.setOption(option);
            }, 100);
        },
        
        piechart() { // 饼图
            this.chatType = 'bing';
            // this.selectYear = this.selectYearCookie;

            for(let i in this.conArr){
                this.$refs.table.toggleRowSelection(this.conArr[i], (i == 0 ? true : false));
            }
            this.selection = [this.conArr[0]];
            this.tableColor(false);
            this.piechart_r();
        },
        piechart_r(){
            let selectArr = this.$refs.table.selection;
            let data = [];
            for(let i in selectArr[0]){
                if(i == 'title' || this.selectYear.indexOf(i) == -1) continue;
                let dataIndex = data.length;
                data[dataIndex] = {name: i, value:0};
                for(let ii in selectArr){
                    // console.log(selectArr[ii][i]);
                    data[dataIndex].value += Number(selectArr[ii][i])
                }
            }
            // console.log(data);
            const option = {
                series: [
                    {
                        type: "pie",
                        hoverAnimation: false,
                        center: ['50%', '52%'],
                        label: {
                            show: true,
                            formatter: "{b}\n{c}", // "{b} : {c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
                            color: "auto",
                        },
                        radius: ["30%", "50%"], //圆环内半径40%，外半径70%
                        data: data
                    },
                ],
            };
            echarts.init(document.getElementById("mychart")).dispose();
            setTimeout(() => {
                this.myChart = echarts.init(document.getElementById("mychart"));
                this.myChart.setOption(option);
            }, 100);
        }
    },
   
};
</script>


<style lang="scss" scoped>
.page {
    padding: 26px 38px 30px;
    .title {
        height: 44px;
        line-height: 44px;
        font-size: 24px;
        color: #111;
        .right {
            float: right;
            height: 44px;
            .search {
                width: 350px;
                height: 44px;
                padding: 10px 18px;
                background: #fff;
                border-radius: 5px;
                box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.1);
                margin-right: 16px;
                float: left;
                img {
                    float: right;
                }
                input {
                    height: 100%;
                    float: left;
                    width: calc(100% - 40px);
                    border: 0;
                    font-size: 14px;
                }

                display: inline-block;
            }
            .btn {
                height: 44px;
                width: 82px;
                line-height: 44px;
                text-align: center;
                background: #0755a7;
                color: #fff;
                font-size: 16px;
                border-radius: 5px;
                display: inline-block;
                float: left;
                margin-right: 26px;
            }
        }
    }
    .menu {
        height: 122px;
        width: 100%;
        margin-top: 18px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        background: #fff;
        padding: 40px 22px;
        .chartnav {
            float: left;
            padding: 3px 0 0;
            .item {
                float: left;
                display: flex;
                align-items: center;
                margin-right: 15px;
                color: #666;
                cursor: pointer;
                img {
                    display: inline-block;
                    margin-right: 6px;
                }
                &.check,
                &:hover {
                    color: #0756a5;
                }
                
            }
        }
    }
    .search {
        float: right;
        .item {
            margin-left: 10px;
            display: flex;
            align-items: center;
            color: #555;
            display: inline-block;
            .el-select{
                margin-left: 12px;
                width: 160px;
            }
            
            .el-date-editor{
                width: 100px;
            }
            >>> .el-range-separator{
                width:40px;
            }
            >>> .el-input__inner{
                padding-right:0
            }
        }
        .btns {
            display: inline-block;
            padding: 0 0 0 10px;
            div {
                width: 60px;
                height: 40px;
                border-radius: 5px;
                text-align: center;
                border: solid 1px #0155b8;
                background: #0155b8;
                color: #fff;
                line-height: 38px;
                display: inline-block;
                // float:left;
                margin-left: 4px;
                cursor: pointer;
                &.plain {
                    background: #fff;
                    color: #0155b8;
                }
            }
        }
    }
    .table {
        width: 100%;
        height: auto;
        padding: 25px 18px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        background: #fff;
        margin-top: 16px;
        position: relative;
        .trcheck{
            padding-left:200px;
            display: flex;
            
            position: absolute;
            width:1490px;
            height:50px;
            top:100px;
            z-index:5
        }
    }
    .tipbox {
        width: 100%;
        background: #fff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin-top: 16px;
        .ttitle {
            padding: 5px 25px 0;
            border-bottom: solid 1px #eeeff1;
            font-size: 18px;
            color: #444;
            line-height: 50px;
            position: relative;
            &::before {
                content: " ";
                position: absolute;
                height: 6px;
                width: 6px;
                background: #0956a8;
                left: 11px;
                bottom: 22px;
            }
        }
        .content {
            padding: 15px 25px 20px;
            font-size: 16px;
            color: #666;
            line-height: 34px;
        }
    }

    .chartbox {
        width: 100%;
        background: #fff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin-top: 16px;
        padding: 0 0 0;
        .ttitle {
            padding: 5px 25px 0;
            border-bottom: solid 1px #eeeff1;
            font-size: 18px;
            color: #444;
            line-height: 50px;
            position: relative;
            &::before {
                content: " ";
                position: absolute;
                height: 6px;
                width: 6px;
                background: #0956a8;
                left: 11px;
                bottom: 22px;
            }
        }
    }
}

</style>

<style>
.el-table th.el-table__cell{
    background-color: #0756A5 !important;
}
.el-table th.el-table__cell>.cell{
    color:#fff !important;
    text-align: center;
}
.el-table td.el-table__cell div{
    text-align: center;
}
.el-table tr:nth-child(3n+1){
    background:#F7F7F7 !important;
}
.el-table tr:nth-child(3n+2){
    background:#fff !important;
}
.el-table tr:nth-child(3n+3){
    background:#DCEFFE !important;
}
.el-table__body tr.hover-row>td.el-table__cell {
    background: none;
}
.el-table .sort-caret.ascending{
    border-bottom-color: #FFF;
}
.el-table .sort-caret.descending{
    border-top-color: #FFF;
}
.el-table .ascending .sort-caret.ascending{
    border-bottom-color:#ee516e;
}
.el-table .descending .sort-caret.descending{
    border-top-color:#ee516e;
}


.el-table__fixed-header-wrapper .el-checkbox__inner {
    display:none
}
.showSelectAll .el-table__fixed-header-wrapper .el-checkbox__inner {
    display:block
}
.el-table__header-wrapper{
    padding-bottom:50px;
    transition: padding .3s;
}
.on .el-table__header-wrapper{
    padding-bottom:0;
}
.el-table__fixed-body-wrapper{
    top: 109px !important;
    transition: top .3s;

}
.on .el-table__fixed-body-wrapper{
    top: 59px !important;
}

.el-checkbox-group{
    width:100%;
    height:100%;
    display:flex;
    justify-content: space-around;
}
.el-checkbox{
    margin-right:0
}
.el-checkbox__label{
    display:none !important;
}


</style>



// WEBPACK FOOTER //
// src/pages/Info.vue